/* WebComponentPageFlip template */
import { Host, h, FunctionalComponent } from '@stencil/core'; // eslint-disable-line @typescript-eslint/no-unused-vars
import { PageFlipComponent } from './cwc-page-flip';

/**
 * Definition of  parameters that the template needs to work.
 */
interface PageFlipTemplateProps {
  /**
   * The class instance that provides controller functionality for the template
   */
  controller: PageFlipComponent;
  // Specify parameters that are required to be passed down to the template here.
}

const PageFlipTemplate: FunctionalComponent<PageFlipTemplateProps> = ({ controller }) => (
  <Host>
    <div class="flip-book" id={`book${controller.productId}`}>
      <div class="flip-book-page" data-density="hard">
        <div class="flip-book-page-content">
          <div class="flip-book-page-image" style={{ 'background-image': 'url(' + controller.coverFront + ')' }}></div>
        </div>
      </div>

      <div class="flip-book-page">
        <div class="flip-book-page-content">
          <div class="flip-book-page-image" style={{ background: '#fff' }}></div>
        </div>
      </div>

      {controller.pages.map((currentPage: string) => (
        <div class="flip-book-page">
          <div class="flip-book-page-content">
            <div class="flip-book-page-image" style={{ 'background-image': 'url(' + currentPage + ')' }}></div>
          </div>
        </div>
      ))}

      <div class="flip-book-page">
        <div class="flip-book-page-content">
          <div class="flip-book-page-image" style={{ background: '#fff' }}></div>
        </div>
      </div>

      <div class="flip-book-page" data-density="hard">
        <div class="flip-book-page-content">
          <div class="flip-book-page-image" style={{ 'background-image': 'url(' + controller.coverBack + ')' }}></div>
        </div>
      </div>
    </div>

    <div class="flip-book-controls" style={!controller.showControls ? { display: 'none' } : {}}>
      <div class="sg-cw-button sg-cw-flat-icon" onClick={() => controller.gotoPreviousPage()}>
        <i class="sg-cw-icon icon-full-arrow-left" />
      </div>
      {!controller.fullscreen ? (
        <div class="sg-cw-button sg-cw-flat-icon" onClick={() => controller.enterFullscreen()}>
          <i class="sg-sw-icon icon-preview" />
        </div>
      ) : (
        ''
      )}
      {controller.fullscreen ? (
        <div class="sg-cw-button sg-cw-flat-icon" onClick={() => controller.exitFullscreen()}>
          <i class="sg-sw-icon icon-close" />
        </div>
      ) : (
        ''
      )}
      <div class="sg-cw-button sg-cw-flat-icon" onClick={() => controller.gotoNextPage()}>
        <i class="sg-cw-icon icon-full-arrow-right" />
      </div>
    </div>
  </Host>
);

export default PageFlipTemplate;
